import { captureLoaded } from '../../../lib/funnels/functions/v1/metrics/captureLoaded'
import { captureSubmitClick } from '../../../lib/funnels/functions/v1/submit/captureSubmitClick'
import { captureSubmitEvent } from '../../../lib/funnels/functions/v1/submit/captureSubmitEvent'
import { captureSubmitSentTo } from '../../../lib/funnels/functions/v1/submit/captureSubmitSentTo'
import { checkSubmitInputs } from '../../../lib/funnels/functions/v1/default/checkSubmitInputs'
import { checkSubmitSelects } from '../../../lib/funnels/functions/v1/default/checkSubmitSelects'
import { getDataFromSubmitEvent } from '../../../lib/funnels/functions/v1/default/getDataFromSubmitEvent'
import { getFunnelCache } from '../../../lib/funnels/functions/v1/default/getFunnelCache'
import { getInputById } from '../../../lib/funnels/functions/v1/default/getInputById'
import { getLoc } from '../../../lib/funnels/functions/v1/middleware/getLoc'
import { getSessionValue } from '../../../lib/funnels/functions/v1/default/getSessionValue'
import { hideFormInput } from '../../../lib/funnels/functions/v1/html/hideFormInput'
import { leadDataToParam } from '@turbodebt/turbo-shared'
import { queryParamsToSession } from '../../../lib/funnels/functions/v1/default/queryParamsToSession'
import { stripPhone } from '../../../lib/funnels/functions/v1/default/stripPhone'
import { resolvePostSubmitUrl } from '../../../lib/funnels/functions/v1/submit/resolvePostSubmitUrl'
import { submitForm } from '../../../lib/funnels/functions/v1/submit/submitForm'
import { updateInput } from '../../../lib/funnels/functions/v1/html/updateInput'
import { updateSession } from '../../../lib/funnels/functions/v1/default/updateSession'

const SESSION_ID = 'tdMainFunnel'

const params = queryParamsToSession(SESSION_ID)

const isConsolidation = params.title === 'consolidation'
const isQualify = params.funnel === 'qualify'

document.addEventListener('DOMContentLoaded', () => {
  captureLoaded()

  const debtOwed = getSessionValue(SESSION_ID, 'debtOwed')
  if (!debtOwed || debtOwed === '0') {
    updateSession(SESSION_ID, 'debtOwed', '9999')
  }

  if (isConsolidation) {
    const formTitle = document.getElementById('form-title')
    if (formTitle) {
      formTitle.textContent = (formTitle.textContent || '').replace(
        'Relief',
        'Consolidation',
      )
    }
  }

  const funnel = getSessionValue(SESSION_ID, 'funnel')
  if (isQualify) {
    document.body.classList.add('qualify')
    updateSession(SESSION_ID, 'funnel', funnel)
  }

  const sessionCache = getFunnelCache()

  const email = sessionCache?.mainEmail || sessionCache?.email || ''
  const firstName = sessionCache?.firstName || sessionCache?.first || ''
  const lastName = sessionCache?.lastName || sessionCache?.last || ''
  const name = sessionCache?.name || `${firstName} ${lastName}`.trim()
  const phone = sessionCache?.phone || ''
  const state = sessionCache?.region || ''

  const emailInput = getInputById('email')
  if (emailInput) {
    updateInput(emailInput, email)
  }
  const nameInput = getInputById('name')
  if (nameInput) {
    updateInput(nameInput, name)
  }
  const phoneInput = getInputById('phone')
  if (phoneInput) {
    updateInput(phoneInput, phone)
  }
  const stateInput = getInputById('state')
  if (stateInput) {
    updateInput(stateInput, state)
  }

  getLoc().then((loc) => {
    updateSession(SESSION_ID, 'region', loc.region || '')
    updateSession(SESSION_ID, 'ip', loc.remoteAddress || '')
    if (loc.region) {
      if (stateInput) {
        updateInput(stateInput, loc.region)
        hideFormInput(stateInput)
      }
    }
  })

  const form = /** @type {HTMLFormElement | null} */ (
    document.getElementById('form')
  )
  if (!form) {
    throw Error('unexpected: form missing')
  }

  const btnSubmit = /** @type {HTMLFormElement | null} */ (
    document.getElementById('button-submit')
  )
  if (!btnSubmit) {
    throw Error('unexpected: btnSubmit missing')
  }
  btnSubmit.addEventListener('click', function () {
    captureSubmitClick()
  })

  /** @type {FormSubmitFieldArray} */
  const requiredInputs = []
  if (emailInput) requiredInputs.push('email')
  if (nameInput) requiredInputs.push('name')
  if (phoneInput) requiredInputs.push('phone')

  /** @type {FormSubmitSelectArray} */
  const requiredSelects = []
  if (stateInput) requiredSelects.push('state')

  form.addEventListener('submit', async function (e) {
    const loader = /** @type {HTMLElement | null} */ (
      document.querySelector('.td-loading-overlay')
    )
    if (loader) {
      loader.style.display = 'flex'
    }

    e.preventDefault()

    const detail = getDataFromSubmitEvent(e)

    const invalidInputs = checkSubmitInputs(detail, requiredInputs)
    const invalidSelects = checkSubmitSelects(detail, requiredSelects)

    if (invalidInputs.length > 0 || invalidSelects.length > 0) {
      console.error(
        'invalid fields:',
        [...invalidInputs, ...invalidSelects].join(),
      )

      if (loader) loader.style.display = 'none'

      return
    }

    // Phone formatting - strip formatting before submission
    if (phoneInput) {
      const strippedPhone = stripPhone(phoneInput.value)
      phoneInput.value = strippedPhone
      // Update the detail object with the stripped phone number
      detail.phone = strippedPhone
    }

    const base64Param = leadDataToParam({ ...detail, ...sessionCache })
    const thanksUrl = `https://funnels.turbodebt.com/thanks/?params=${base64Param}`

    captureSubmitEvent()
    try {
      const redirectUrl = await submitForm(detail)
      const href = resolvePostSubmitUrl(redirectUrl, thanksUrl)
      captureSubmitSentTo(/thanks/i.test(href) ? 'thanks' : 'chat')
      window.location.href = href
    } catch (error) {
      console.error('submit error:', error)
      loader?.setAttribute('error', 'true')
      captureSubmitSentTo('thanks')
      window.location.href = thanksUrl
      // throw error
    }
  })
})
